// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCloudOutlinedSvg from "@fishx/icons-svg/es/asn/PCloudOutlined";
import FishxIcon from '../components/FishxIcon';

var PCloudOutlined = function PCloudOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCloudOutlinedSvg
  }));
};

PCloudOutlined.displayName = 'PCloudOutlined';
export default React.forwardRef(PCloudOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCloudOutlined.js
// module id = 3289
// module chunks = 0